module.exports = __webpack_public_path__ + "assets/img/fa-logo.deea1bef.png";